import axios from "axios";
import ErrorParser from '../../../helpers/services/error.parser';

const AttainmentsService = {
  attainments: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/attainments",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  delete: async function (id) {
    const requestData = {
      method: "post",
      url: "/api/management/attainments/delete",
      data: { id: id }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  update: async function (attainments) {
    const requestData = {
      method: "post",
      url: "/api/management/attainments/update",
      data: attainments
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  import: async function (formData) {
    const requestData = {
      method: "post",
      url: "/imports/attainments",
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  assessmentregimes: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/attainments/ar",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }
};

export default AttainmentsService;
